const normalizeFacetValues = facetString => {
  const [facetName, facetValuesString] = facetString.split(":");
  const facetValues = facetValuesString.split(",");
  const normalizedFacetValues = facetValues.sort();
  const normalizedFacetValuesString = normalizedFacetValues.join(",");

  return `${facetName}:${normalizedFacetValuesString}`;
};

export const normalizeRefineParameter = ({ facets }) => {
  const normalizedFacets = facets.map(normalizeFacetValues).sort();

  return normalizedFacets.join("|");
};
